import image1 from '../components/assets/staff-cleaned-v3/1.jpg';
import image2 from '../components/assets/staff-cleaned-v3/2.jpg';
import image3 from '../components/assets/staff-cleaned-v3/3.jpg';
import image4 from '../components/assets/staff-cleaned-v3/4.jpg';
import image5 from '../components/assets/staff-cleaned-v3/5.jpg';
import image6 from '../components/assets/staff-cleaned-v3/6.jpg';
import image7 from '../components/assets/staff-cleaned-v3/7.jpg';
import image8 from '../components/assets/staff-cleaned-v3/8.jpg';
import image9 from '../components/assets/staff-cleaned-v3/9.jpg';
import image10 from '../components/assets/staff-cleaned-v3/10.jpg';
import image11 from '../components/assets/staff-cleaned-v3/11.jpg';
import image12 from '../components/assets/staff-cleaned-v3/12.jpg';
import image13 from '../components/assets/staff-cleaned-v3/13.jpg';
import image14 from '../components/assets/staff-cleaned-v3/14.jpg';
import image15 from '../components/assets/staff-cleaned-v3/15.jpg';
import image16 from '../components/assets/staff-cleaned-v3/16.jpg';
import image17 from '../components/assets/staff-cleaned-v3/17.jpg';
import image18 from '../components/assets/staff-cleaned-v3/18.jpg';
import image19 from '../components/assets/staff-cleaned-v3/19.jpg';
import image20 from '../components/assets/staff-cleaned-v3/20.jpg';
import image21 from '../components/assets/staff-cleaned-v3/21.jpg';
import image22 from '../components/assets/staff-cleaned-v3/22.jpg';
import image23 from '../components/assets/staff-cleaned-v3/23.jpg';

export const teacherSections = [
  {
    key: 'teachers-group-leadership',
    staff: [
      {
        image: image1,
        nameZh: '\u66fe\u6155\u5a49',
        nameEn: 'Lee, Mo Yuen',
        roleKey: 'teacher-role-principal',
      },
      {
        image: image2,
        nameZh: '\u5f20\u56ed\u56ed',
        nameEn: 'McCoo Zhang, Yuanyuan',
        roleKey: 'teacher-role-vice-principal',
      },
    ],
  },
  {
    key: 'teachers-group-mandarin',
    staff: [
      { image: image3, nameZh: '\u8d75\u5a1c', nameEn: 'Zhao, Na', roleKey: 'teacher-role-year-1' },
      { image: image4, nameZh: '\u6d82\u536b\u7ea2', nameEn: 'Tu, Weihong', roleKey: 'teacher-role-year-1' },
      { image: image5, nameZh: '\u859b\u4e3d\u541b', nameEn: 'Xue, Lijun', roleKey: 'teacher-role-year-2' },
      { image: image6, nameZh: '\u5468\u96c5\u6c81', nameEn: 'Zhou, Yaqin', roleKey: 'teacher-role-year-2' },
      { image: image7, nameZh: '\u6881\u7389\u5f71', nameEn: 'Liang, Yuying', roleKey: 'teacher-role-year-3' },
      { image: image8, nameZh: '\u97e9\u6021', nameEn: 'Han, Yi', roleKey: 'teacher-role-year-3' },
      { image: image9, nameZh: '\u7ba1\u6653\u5a1c', nameEn: 'Guan, Xiaona', roleKey: 'teacher-role-year-4' },
      { image: image10, nameZh: '\u9ec4\u7389\u5b81', nameEn: 'Huang, Yuning', roleKey: 'teacher-role-year-4' },
      { image: image11, nameZh: '\u9093\u60a6', nameEn: 'Deng, Yue', roleKey: 'teacher-role-year-5' },
      { image: image12, nameZh: '\u5f20\u8574\u840c', nameEn: 'Zhang, Yunmeng', roleKey: 'teacher-role-year-6' },
      { image: image13, nameZh: '\u8f9b\u7ea2', nameEn: 'Xin, Hong', roleKey: 'teacher-role-year-7' },
      { image: image14, nameZh: '\u725f\u601d\u6d01', nameEn: 'Mou, Sijie', roleKey: 'teacher-role-year-8' },
      { image: image15, nameZh: '\u5f90\u5c0f\u7136', nameEn: 'Xu, Xiaoran', role: 'GCSE' },
      { image: image16, nameZh: '\u90ed\u5f3a', nameEn: 'Guo, Qiang', role: 'GCSE' },
      { image: image17, nameZh: '\u6c88\u65fb', nameEn: 'Shen, Min', role: 'A-level' },
    ],
  },
  {
    key: 'teachers-group-cantonese',
    staff: [
      { image: image18, nameZh: '\u53e4\u66fe\u7eee\u4e91', nameEn: 'Ku, Yeewan Rita', roleKey: 'teacher-role-cantonese' },
      { image: image19, nameZh: '\u7f57\u7fe0\u83b2', nameEn: 'Lo, Choilin', roleKey: 'teacher-role-cantonese' },
      { image: image20, nameZh: '\u5218\u6cf3\u8bd7', nameEn: 'Lau, Wingsi', roleKey: 'teacher-role-cantonese' },
      { image: image21, nameZh: '\u9648\u79c0\u4e3d', nameEn: 'Chan, Saulai', roleKey: 'teacher-role-cantonese' },
    ],
  },
  {
    key: 'teachers-group-speaking',
    staff: [
      { image: image22, nameZh: '\u90ed\u654f', nameEn: 'Guo, Min', roleKey: 'teacher-role-speaking' },
      { image: image23, nameZh: '\u738b\u6052', nameEn: 'Wang, Heng', roleKey: 'teacher-role-speaking' },
    ],
  },
];
